import hasInstoreChannel from "client/utils/hasInstoreChannel";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class IsResidenceField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "No",
      propertyName: "isResidence",
      pickList: ["Yes", "No"],
      uiFieldType: "RadioInput",
      ...opts,
    });
  }

  get applicable(): boolean {
    const salesChannel = this._model.storeDetails.salesChannel.value;
    return hasInstoreChannel(salesChannel);
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
